@if (vaultNav(); as nav) {
  @if (nav.vaults.length > 1) {
    <bit-nav-item
      class="tw-mb-2"
      [text]="'allItems' | i18n"
      [route]="allItemsRoute"
      [queryParamsHandling]="queryParamsHandling(allItemsRoute)"
      [routerLinkActiveOptions]="exactRouteOptions"
    >
      <bit-icon-tile
        [icon]="allItemsTile.icon"
        [variant]="allItemsTile.variant ?? 'primary'"
        [emphasis]="allItemsTile.emphasis ?? 'subtle'"
        size="sm"
      />
    </bit-nav-item>
  }

  <ng-template #vaultGroups>
    @for (vault of nav.vaults; track vault.id) {
      @if (vault.type === VaultNavItemType.Personal) {
        <bit-nav-item
          [text]="vault.label"
          [route]="vaultRoute(vault)"
          [queryParamsHandling]="queryParamsHandling(vaultRoute(vault))"
        >
          @let personalTile = tile(vault);
          <bit-icon-tile
            [icon]="personalTile.icon"
            [variant]="personalTile.variant ?? 'primary'"
            [color]="personalTile.color"
            [emphasis]="personalTile.emphasis ?? 'subtle'"
            size="sm"
          />
        </bit-nav-item>
      } @else {
        <bit-nav-group [text]="vault.label" [open]="nav.organizationDataOwnership">
          @let vaultTile = tile(vault);
          <bit-icon-tile
            [icon]="vaultTile.icon"
            [variant]="vaultTile.variant ?? 'primary'"
            [color]="vaultTile.color"
            [emphasis]="vaultTile.emphasis ?? 'subtle'"
            size="sm"
          />
          @if (!vault.enabled) {
            <bit-icon
              slot="end"
              name="bwi-exclamation-triangle"
              [ariaLabel]="'organizationIsDisabled' | i18n"
              appA11yTitle="{{ 'organizationIsDisabled' | i18n }}"
            ></bit-icon>
          }
          <bit-nav-item
            icon="bwi-list-alt"
            [text]="'allVaultItems' | i18n"
            [route]="vaultRoute(vault)"
            [queryParamsHandling]="queryParamsHandling(vaultRoute(vault))"
            [routerLinkActiveOptions]="exactRouteOptions"
          ></bit-nav-item>
          @if (vault.defaultUserCollectionId) {
            <bit-nav-item
              icon="bwi-user"
              [text]="'myItemsV2' | i18n"
              [route]="myItemsRoute(vault)"
              [queryParamsHandling]="queryParamsHandling(myItemsRoute(vault))"
            ></bit-nav-item>
          }
          <!--
            Left on the default subset match, so it also lights on the folder drill-ins nested
            beneath it — those have no nav entry of their own, and the list they were reached from
            stands in for them.
          -->
          <bit-nav-item
            icon="bwi-shared-folder"
            [text]="'sharedFolders' | i18n"
            [route]="sharedFoldersRoute(vault)"
            [queryParamsHandling]="queryParamsHandling(sharedFoldersRoute(vault))"
          ></bit-nav-item>
        </bit-nav-group>
      }
    }
  </ng-template>

  @if (personalOnly()) {
    @let loneVault = nav.vaults[0];
    <!-- A lone vault still routes to /vault; only the label differs. -->
    <bit-nav-item
      [text]="loneVault.label"
      [route]="allItemsRoute"
      [queryParamsHandling]="queryParamsHandling(allItemsRoute)"
      [routerLinkActiveOptions]="exactRouteOptions"
    >
      @let loneTile = tile(loneVault);
      <bit-icon-tile
        [icon]="loneTile.icon"
        [variant]="loneTile.variant ?? 'primary'"
        [color]="loneTile.color"
        [emphasis]="loneTile.emphasis ?? 'subtle'"
        size="sm"
      />
    </bit-nav-item>
  } @else if (nav.organizationDataOwnership) {
    <ng-container [ngTemplateOutlet]="vaultGroups"></ng-container>
  } @else if (nav.vaults.length > 1) {
    <bit-nav-section [label]="'vaults' | i18n">
      <ng-container [ngTemplateOutlet]="vaultGroups"></ng-container>
    </bit-nav-section>
  }
}
